import { getAllUserDevice } from 'src/@api/login'

let userDeviceRequest = null
let userDeviceRequestToken = null

const readAccessToken = () => {
  try {
    return typeof window === 'undefined' ? '' : localStorage.getItem('accessToken') || ''
  } catch {
    return ''
  }
}

/** 只有成功且确实返回数组的响应，才代表有效设备包列表。 */
export const isValidUserDeviceListResponse = response => {
  const code = response?.code

  return Boolean(response && (code == null || code === '' || [0, 200].includes(Number(code))) && Array.isArray(response.data))
}

export const readCachedUserDeviceList = () => {
  if (typeof window === 'undefined') return null

  try {
    const cached = JSON.parse(localStorage.getItem('allDeviceUser') || 'null')

    return Array.isArray(cached) ? cached : null
  } catch {
    return null
  }
}

const writeCachedUserDeviceList = devices => {
  if (typeof window === 'undefined' || !Array.isArray(devices)) return

  try {
    localStorage.setItem('allDeviceUser', JSON.stringify(devices))
  } catch {
    // Keep the API response usable when browser storage is unavailable.
  }
}

/** Reuse the auth bootstrap's device list across dashboard consumers. */
export const getUserDeviceList = ({ forceRefresh = false, requestConfig = {} } = {}) => {
  const token = readAccessToken()
  if (userDeviceRequest && userDeviceRequestToken === token) return userDeviceRequest

  if (!forceRefresh) {
    const cached = readCachedUserDeviceList()
    if (cached !== null) return Promise.resolve({ code: 0, data: cached })
  }

  const request = getAllUserDevice({}, requestConfig)
    .then(response => {
      if (token === readAccessToken() && isValidUserDeviceListResponse(response)) {
        writeCachedUserDeviceList(response.data)
      }

      return response
    })
    .finally(() => {
      if (userDeviceRequest === request) {
        userDeviceRequest = null
        userDeviceRequestToken = null
      }
    })

  userDeviceRequest = request
  userDeviceRequestToken = token

  return request
}
